import { useSelector } from 'react-redux';
import { getIsPartialCampaign, selectRecommendedPrice } from '../selector';
import { ToolTipDialog } from 'components/Shared/ToolTip/themes/BGH-RD3';
import { NO_ELEMENT, rm, withCurrentPage } from 'utils';
import cn from 'classnames';
import styles from './recommendedPrice.scss';

interface RecommendedPriceProps {
  priceString?: string;
  isPartialCampaign?: boolean;
  isProductPage?: boolean;
}

export const RecommendedPrice = ({
  priceString,
  isPartialCampaign,
  isProductPage
}: RecommendedPriceProps = {}) => {
  const selectorPriceString = useSelector(selectRecommendedPrice);
  const selectorIsPartialCampaign = useSelector(withCurrentPage(getIsPartialCampaign));
  const finalRecommendedPriceString = priceString ?? selectorPriceString;
  const finalIsPartialCampaign = isPartialCampaign ?? selectorIsPartialCampaign;

  if (!finalRecommendedPriceString || finalIsPartialCampaign) return NO_ELEMENT;

  const showTooltip = !priceString;
  const recommendedPricePrefix = isProductPage
    ? rm('Product_Recommended_Price_PDP')
    : rm('Product_Recommended_Price');

  return (
    <div className={cn(styles.wrapper, { [styles.noPadding]: !showTooltip })}>
      <span className={styles.text}>
        {recommendedPricePrefix} <span dangerouslySetInnerHTML={{ __html: finalRecommendedPriceString }} />
      </span>
      {showTooltip && <ToolTipDialog text={rm('recommended_price_info_text')} hoverText="!" />}
    </div>
  );
};
